import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=8af8fd86&"
import script from "./focus.vue?vue&type=script&lang=js&"
export * from "./focus.vue?vue&type=script&lang=js&"
import style0 from "./focus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports